import BaseQuery from "@/stateManagement/BaseQuery";
import { singleton } from "tsyringe";

import type { BoostCampaignState } from "../store/RewardsBoostCampaignStore";
import RewardsBoostCampaignStore from "../store/RewardsBoostCampaignStore";

@singleton()
class RewardsBoostCampaignQuery extends BaseQuery<BoostCampaignState> {
    constructor(protected store: RewardsBoostCampaignStore) {
        super(store);
    }

    boostCampaign$ = this.select((state) => state.boostCampaign);
    status$ = this.select((state) => state.status);
}

export default RewardsBoostCampaignQuery;
